import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuditFeeRecoveryComponent } from './reports-components/audit-fee-recovery/audit-fee-recovery.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AddTargetComponent } from './components/add-target/add-target.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AddArbitratoinDataComponent } from './components/add-arbitratoin-data/add-arbitratoin-data.component';
import { PdsMisutilizationComponent } from './components/pds-misutilization/pds-misutilization.component';
import { GoodDistributionComponent } from './components/good-distribution/good-distribution.component';
import { AddmisutilizationCaseComponent } from './components/addmisutilization-case/addmisutilization-case.component';
import { AddConsumerGoodsComponent } from './components/add-consumer-goods/add-consumer-goods.component';
import { AddElecetionDataComponent } from './components/add-elecetion-data/add-elecetion-data.component';
import { AddExecutionCaseComponent } from './components/add-execution-case/add-execution-case.component';
import { FertilizeInspectionComponent } from './components/fertilize-inspection/fertilize-inspection.component';
import { FpsInspectionComponent } from './components/fps-inspection/fps-inspection.component';
import { InspectionDetailsComponent } from './components/inspection-details/inspection-details.component';
import { UnderLiquiditionComponent } from './components/under-liquidition/under-liquidition.component';
import { MisAppropriationComponent } from './components/mis-appropriation/mis-appropriation.component';
import { PdsStockLiftingComponent } from './components/pds-stock-lifting/pds-stock-lifting.component';
import { DeistributionFertilizerComponent } from './components/deistribution-fertilizer/deistribution-fertilizer.component';
import { PDSmisutilizationCaseComponent } from './components/pdsmisutilization-case/pdsmisutilization-case.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AuditFeeMPRComponent } from './components/audit-fee-mpr/audit-fee-mpr.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AddAuditConductedComponent } from './components/add-audit-conducted/add-audit-conducted.component';
import { AddAuditFeesmprComponent } from './components/add-audit-feesmpr/add-audit-feesmpr.component';
import { ProgressAndDevelopmentComponent } from './components/progress-and-development/progress-and-development.component';
import { ProgressAndDevelopmentReportComponent } from './components/progress-and-development-report/progress-and-development-report.component';
import { DevelopmentBudgetExpenditureComponent } from './components/development-budget-expenditure/development-budget-expenditure.component';
import { DevelopmentBudgetExpenditurereportComponent } from './components/development-budget-expenditurereport/development-budget-expenditurereport.component';
const routes: Routes = [
  {
    path: "",
    component: AuditFeeRecoveryComponent,
  },
  {
    path: "audit-fee-recovery",
    component: AuditFeeRecoveryComponent,
  },
  {
    path:"monthlyTarget",
    component:AddTargetComponent
  },
  {
    path:"addArbitratoinData",
    component:AddArbitratoinDataComponent
  },
  // {
  //   path:"PdsMisutilization",
  //   component:PdsMisutilizationComponent
  // },
  {
    path:"addmisutilizationCase",
    component:AddmisutilizationCaseComponent
  },
  {
    path:"addConsumerGood",
    component:AddConsumerGoodsComponent
  },
  {
    path:"AddElecetionCases",
    component:AddElecetionDataComponent
  },
  {
    path:"AddExecutionCases",
    component:AddExecutionCaseComponent
  },
  {
    path:"UnderLiquidition",
    component:UnderLiquiditionComponent
  },
  {
    path:"FpsInspection",
    component:FpsInspectionComponent
  },
  {
    path:"misAppropriation",
    component:MisAppropriationComponent
  },
  {
    path:"fertilizeDepot",
    component:FertilizeInspectionComponent
  },
  {
    path:"pdsStockLifting",
    component:PdsStockLiftingComponent
  },
  {
    path:"fertilizerdistribute",
    component:DeistributionFertilizerComponent
  },
  {
    path:"PdsMisutilization",
    component:PDSmisutilizationCaseComponent
  },
  {
    path:"CooInspection",
    component:InspectionDetailsComponent
  },
  {
    path:"auditFeeMPR",
    component:AuditFeeMPRComponent
  },
  {
    path:"auditConducted",
    component:AddAuditConductedComponent
  },
  {
    path:"auditFeesMPR",
    component:AddAuditFeesmprComponent
  },
    {
    path:"progressReport",
    component:ProgressAndDevelopmentReportComponent
  },
  {
    path:"progressAndDevelopment",
    component:ProgressAndDevelopmentComponent
  },

  {
    path:"progressAndDevelopment/:financialYear",
    component:ProgressAndDevelopmentComponent
  },
  {
    path:"developmentBudgetExpenditure",
    component:DevelopmentBudgetExpenditureComponent
  },

   {
    path:"developmentBudgetExpenditureReport",
    component:DevelopmentBudgetExpenditurereportComponent
  },
  // {
  //   path:"developmentBudgetExpenditure/:financialYear,:blockId",
  //   component:DevelopmentBudgetExpenditureComponent
  // },
 


];


@NgModule({
  declarations: [
    AuditFeeRecoveryComponent,
    AddTargetComponent,
    AddArbitratoinDataComponent,
    PdsMisutilizationComponent,
    GoodDistributionComponent,
    AddmisutilizationCaseComponent,
    AddConsumerGoodsComponent,
    AddElecetionDataComponent,
    AddExecutionCaseComponent,
    FertilizeInspectionComponent,
    FpsInspectionComponent,
    InspectionDetailsComponent,
    UnderLiquiditionComponent,
    MisAppropriationComponent,
    PdsStockLiftingComponent,
    DeistributionFertilizerComponent,
    PDSmisutilizationCaseComponent,
    AuditFeeMPRComponent,
    AddAuditConductedComponent,
    AddAuditFeesmprComponent,
    ProgressAndDevelopmentComponent,
    ProgressAndDevelopmentReportComponent,
    DevelopmentBudgetExpenditureComponent,
    DevelopmentBudgetExpenditurereportComponent
  
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NgxDatatableModule,
    NgMultiSelectDropDownModule,
    NgSelectModule
    ]
})
export class ReportsModule { }
